import React, { useState, useEffect } from 'react';
import './TauriBreadcrumbs.css';
import config from '../../config.json';
import TauriBreadcrumbHeadingTitle from './TauriBreadcrumbHeadingTitle/TauriBreadcrumbHeadingTitle';
import TauriIdentifierDropdown from './TauriBreadcrumbDropdown/TauriIdentifierDropdown/TauriIdentifierDropdown';
import TauriConfigTypeCodeDropdown from './TauriBreadcrumbDropdown/TauriConfigTypeCodeDropdown/TauriConfigTypeCodeDropdown';
import TauriMonthAndYearDropdown from './TauriBreadcrumbDropdown/TauriMonthAndYearDropdown/TauriMonthAndYearDropdown';
import TauriImage from '../TauriImage/TauriImage';
import TauriExportDialog from '../TauriExportDialog/TauriExportDialog';
import { useFilterContext } from '../TauriGlobalContext/TauriGlobalContext';

const TauriBreadcrumbs = ({ parent, name, separator }) => {
    const [paths, setPaths] = useState([]);

    const getUserData = localStorage.getItem('UserData');
    const decodedUserData = JSON.parse(atob(getUserData));

    const user = decodedUserData?.UserPermission?.Data?.Children?.find(child => child.Name === 'DataScope').Children;
    const userCompany = user.find(item => item.CompanyId == config.CompanyId);
    localStorage.setItem('ConfigTypeCode', userCompany?.ConfigTypeCode);

    const { updateFilterValue } = useFilterContext();

    const userAccessLevel = userCompany?.Access || -1;

    const loadBreadcrumbs = (parent, name) => {
        const matchingRoutes = findMatchingRoutes(parent, name);
        const extractedRoutes = extractRoutes(matchingRoutes);
        if (extractedRoutes[0]) {
            if (extractedRoutes[0].length == 1) {
                setPaths(extractedRoutes[0]);
            } else {
                const remainingRoutes = extractedRoutes[0].slice(1);
                setPaths(remainingRoutes);
            }
        }
    }

    useEffect(() => {
        if (parent.id) {
            loadBreadcrumbs(parent, name)
        }
    }, [parent, name])

    const findMatchingRoutes = (json, name) => {
        const matchingRoutes = [];

        const traverse = (node, currentPath, route) => {
            if (node.name === currentPath) {
                matchingRoutes.push(route);
            }

            if (node.children) {
                for (const child of node.children) {
                    traverse(child, currentPath, [...route, child]);
                }
            }
        };

        traverse(json, name, [json]);
        return matchingRoutes;
    };

    const extractRoutes = (matchingRoutes) => {
        const extractedRoutes = [];
        for (const route of matchingRoutes) {
            const extractedRoute = [];
            for (const node of route) {
                extractedRoute.push({
                    id: node.id,
                    name: node.name,
                    icon: node.icon,
                    path: node.path,
                    roleLevel: node.roleLevel
                });
            }
            extractedRoutes.push(extractedRoute);
        }
        return extractedRoutes;
    };

    const handleOnclick = (clickName) => {
        if (parent.id) {
            loadBreadcrumbs(parent, clickName);
        }
    }

    const [showExport, setShowExport] = useState(false);
    const [selectedDates, setSelectedDates] = useState(() => ({
        FromMonth: null,
        FromYear: null,
        ToMonth: null,
        ToYear: null,
    }));

    const [codenameKey, setCodenameKey] = useState('');
    const [selectedCode, setSelectedCode] = useState('');
    const [selectedConfigTypeCode, setSelectedConfigTypeCode] = useState(userCompany?.ConfigTypeCode?.split(',')[0]?.toString());

    useEffect(() => {
        updateFilterValue({
            FromMonth: selectedDates.FromMonth?.toString(),
            FromYear: selectedDates.FromYear?.toString(),
            ToMonth: selectedDates.ToMonth?.toString(),
            ToYear: selectedDates.ToYear?.toString(),
            [codenameKey]: selectedCode,
            ConfigTypeCode: selectedConfigTypeCode.toString()
        });

    }, [selectedDates, selectedConfigTypeCode, selectedCode]);

    const handleExportClick = () => {
        setShowExport(true);
    };

    const handleHideExport = () => {
        setShowExport(false);
    };

    const handleSelectedIdentifier = (key, value) => {
        setSelectedCode(value);
        setCodenameKey(key);
    };

    const handleDateChange = (dateValue) => {
        setSelectedDates(dateValue);
    };

    const handleConfigTypeCodeChange = (configtype) => {
        setSelectedConfigTypeCode(configtype)
    };

    return (
        <div className="breadcrumbs-container d-flex flex-column flex-xl-row justify-content-between align-items-start px-2 px-xl-4">
            <div className="left-component d-flex align-items-center">
                <TauriBreadcrumbHeadingTitle paths={paths} handleOnclick={handleOnclick} separator={separator} />
            </div>
            <div className="right-component">
                <div className="tauri-filter d-flex align-items-center">
                    <TauriMonthAndYearDropdown onDateChange={handleDateChange} />
                    {(decodedUserData?.CodeList?.length > 0) &&
                        <TauriIdentifierDropdown AccessRange={userCompany?.AccessRange} AccessCodes={decodedUserData?.CodeList || []} AccessLevel={userCompany?.Access} handleSelected={handleSelectedIdentifier} />
                    }

                    {(userCompany?.ConfigTypeCode.split(',').length > 1) &&
                        <TauriConfigTypeCodeDropdown
                            ConfigCode={userCompany?.ConfigTypeCode}
                            handleSelected={handleConfigTypeCodeChange}
                        />
                    }

                    <TauriImage
                        localImage="/Images/download.svg"
                        alt="Download"
                        className="d-none"
                        onClick={handleExportClick}
                    />
                    <TauriImage localImage="/Images/email.svg" alt="Email" className="d-none" />
                    <TauriImage localImage="/Images/share.svg" alt="Share" className="d-none" />

                    {showExport &&
                        <TauriExportDialog show={showExport} onHide={handleHideExport} />
                    }
                </div>
            </div>
        </div>
    );
};

export default TauriBreadcrumbs;
